import { AllValidTherapeuticArea } from 'basics/enums/biogen.enums';
import { InitiativeCountry } from 'basics/enums/country.enums';
import { BiogenFunction, CepStatus, CiStatus, TacticStatus } from 'basics/enums/maya.enums';
import { ProductType } from 'basics/types/products.types';
import { transformInputDateToUTCFormat } from 'basics/utils/dates/dates.utils';
import { DashboardFilter } from 'generated/maya.types';
import { YodaFieldValue } from 'yoda-ui/yodaForm/yodaForm.types';

type MaybeArray<T> = T[] | null | undefined;
const hasValues = <T>(field: MaybeArray<T>): field is T[] => Array.isArray(field) && field.length > 0;

export const formatUserDashboardFilter = (data: YodaFieldValue): Partial<DashboardFilter> => {
  return {
    countries: hasValues(data.countries) ? data.countries : undefined,
    therapeuticArea: hasValues(data.therapeuticArea) ? data.therapeuticArea : undefined,
    product: hasValues(data.product) ? data.product : undefined,
    cepFunction: hasValues(data.cepFunction) ? data.cepFunction : undefined,
    cepStatus: hasValues(data.cepStatus) ? data.cepStatus : undefined,
    ...transformInputDateToUTCFormat(data.date),
  };
};

export const formatAdminDashboardFilter = (data: YodaFieldValue, allProducts: ProductType[]): DashboardFilter => {
  const allProductKeys = allProducts.map((product) => product.productExternalID);

  return {
    countries: hasValues(data.countries)
      ? data.countries
      : Object.keys(InitiativeCountry),
    status: [CiStatus.ACTIVE, CiStatus.DRAFT],
    therapeuticArea: hasValues(data.therapeuticArea)
      ? data.therapeuticArea
      : Object.values(AllValidTherapeuticArea),
    product: hasValues(data.product)
      ? data.product
      : allProductKeys,
    cepFunction: hasValues(data.cepFunction)
      ? data.cepFunction
      : Object.values(BiogenFunction),
    tacticStatus: [TacticStatus.EMPTY, TacticStatus.DRAFT, TacticStatus.APPROVED],
    cepStatus: hasValues(data.cepStatus)
      ? data.cepStatus
      : [CepStatus.DRAFT, CepStatus.FEEDBACK, CepStatus.APPROVED],
    ...transformInputDateToUTCFormat(data.date),
  };
};
